import type { SVGProps } from 'react';
const SvgShieldSplash = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 59" {...props}>
    <g fill="none">
      <path
        fill="#CBD5E0"
        d="M49.905 22c3.083 11.197-.45 23.005-9.243 30.112-8.8 7.1-22.851 9.506-31.375 3.407s-11.513-20.696-7.574-33.1C5.66 10.023 16.541-.189 26.828.003 37.115.193 46.821 10.795 49.905 22"
      />
      <path
        fill="#000"
        d="M17.88 26.808a1.073 1.073 0 0 0-1.488-.008l-1.986 1.934a1.026 1.026 0 0 0-.008 1.46l7.945 7.865c.41.404 1.076.404 1.487.008l15.102-14.714a1.026 1.026 0 0 0 .01-1.46l-1.97-1.952a1.07 1.07 0 0 0-1.487-.008l-12.372 12.05zm26.539-12.616-16.8-6.876a4.29 4.29 0 0 0-3.229 0l-16.8 6.876C6.024 14.828 5 16.332 5 17.999c0 17.06 10.019 28.852 19.381 32.685a4.29 4.29 0 0 0 3.229 0C35.109 47.616 47 37.02 47 18a4.13 4.13 0 0 0-2.581-3.807zM26 46.877C17.469 43.387 9.2 32.55 9.2 17.999L26 11.123 42.8 18c0 14.937-8.61 25.526-16.8 28.878z"
      />
    </g>
  </svg>
);
export default SvgShieldSplash;
